import React, { ReactNode } from 'react';
import { Col } from 'antd';
import cx from 'classnames';

import styles from '../HistoryCard.module.less';

type Props = {
  title?: string | ReactNode;
  emptyText?: string;
  value?: null | string | React.ReactNode;
  dataId?: string;
};

export default function HistoryField(props: Props) {
  const { title, value, emptyText = 'No data', dataId = '' } = props;
  const normalizedValue =
    typeof value === 'string' && value.trim() === '' ? undefined : value;
  const isValueSpecified = !!normalizedValue;

  return (
    <Col xs={24} md={12}>
      {title && <div className="title">{title}:</div>}

      <div>
        <span
          className={cx({ [styles.noDataMessage]: !isValueSpecified })}
          data-id={dataId}
        >
          {isValueSpecified ? normalizedValue : emptyText}
        </span>
      </div>
    </Col>
  );
}
